// 判断是不是微信内置浏览器
export function isWeixinBrower() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) == 'micromessenger'
}
/**
 * 判断打开H5的浏览器ua类型
 * @return {String} 判断出的类型 'wechat'|'ios'|'android'
 */
export function checkUserAgentOpenType() {
  var ua = navigator.userAgent
  // 微信浏览器环境
  const isWeixinBrower =
    ua.toLowerCase().match(/MicroMessenger/i) == 'micromessenger'
  // ios环境
  const isIOSWebView =
    /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(ua) ||
    /(iPhone|iPod|iPad).*AppleWebKit/i.test(ua)
  if (isWeixinBrower) {
    return 'wechat'
  } else if (isIOSWebView) {
    return 'ios'
  } else {
    return 'android'
  }
}
// 渠道码invitation，目前只有微信内置浏览器有
export function getInvitation() {
  if (!window.location.search) return
  const u = new URLSearchParams(window.location.search)
  return u.get('invitation')
}

// 储存当前页页面的用户token
const user_token = 'USER_TOKEN'
export function saveUserToken(url) {
  const u = new URL(url)
  const token = u.searchParams.get('token')
  if (token) {
    localStorage.setItem(user_token, token)
    return token
  }
}
// 获取储存的token
export function getUserToken() {
  return localStorage.getItem(user_token)
}

/* 百度统计 */
const baidu_script = token => `
var _hmt = _hmt || []
;(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?${token}'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()
`
export const analytics_baidu = token => {
  let script = document.createElement('script')
  script.text = baidu_script(token)
  script.type = 'text/javascript'
  document.querySelector('head').appendChild(script)
}
